import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import * as moment from 'moment';
import {WeekOpeningHours} from "../../../models/mission";
import {ToastHandlerService} from "../../../../../shared/services/toast-handler.service";
import {TranslateService} from "@ngx-translate/core";
import {Address} from "../../../../../admin/modules/admin-places/models/address";

@Component({
    selector: 'pv-common-mission-datetime-dialog',
    templateUrl: './common-mission-datetime-dialog.component.html',
    styleUrls: ['./common-mission-datetime-dialog.component.scss'],
    standalone: false
})
export class CommonMissionDatetimeDialogComponent implements OnInit {

  public afterDate: moment.Moment;
  public afterTime: string;
  public beforeDate: moment.Moment;
  public beforeTime: string;

  @Input() after: moment.Moment;
  @Input() before: moment.Moment;
  @Input() canEditDate: boolean;
  @Input() addressData: Address;
  @Output() submitEvent = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<CommonMissionDatetimeDialogComponent>,
              private toastService: ToastHandlerService,
              private translate: TranslateService) { }

  ngOnInit(): void {
    if (this.after !== null && this.before !== null) {
      this.afterDate = moment(this.after);
      this.afterTime = moment(this.after).format('HH:mm');
      this.beforeDate = moment(this.before);
      this.beforeTime = moment(this.before).format('HH:mm');
    }
  }

  private parseTime(time: string) {
    const [hour, minute] = time.split(':');
    return {hour: parseInt(hour, 10), minute: parseInt(minute, 10)};
  }

  private isWithinWorkingHours(date: moment.Moment, workingHours: WeekOpeningHours) {
    const dayOfWeek = date.locale('en').format('dddd').toLowerCase();
    const dayHours = workingHours[dayOfWeek];
    const time = date.format('HH:mm');

    if (!dayHours || !dayHours.isOpen) {
      return false;
    }

    return dayHours.hours.some(({ hours_from, hours_to }) => {
      const startMoment = moment(hours_from, 'HH:mm');
      const endMoment = moment(hours_to, 'HH:mm');
      const timeMoment = moment(time, 'HH:mm');

      return timeMoment.isSameOrAfter(startMoment) && timeMoment.isSameOrBefore(endMoment);
    });
  }

  submit() {
    const afterTime = this.parseTime(this.afterTime);
    const after = moment(this.afterDate).set({hour: afterTime.hour, minute: afterTime.minute, second: 0, millisecond: 0});

    const beforeTime = this.parseTime(this.beforeTime);
    const before = moment(this.beforeDate).set({hour: beforeTime.hour, minute: beforeTime.minute, second: 0, millisecond: 0});

    if (after.isSameOrAfter(before)) {
      this.toastService.showErrorToasts(
        this.translate.instant('modules.mission.mission_form.datetime_dialog.error_slot')
      );
      return;
    }

    if (this.addressData && this.addressData.isRestitutionCenter && this.addressData.workingHours) {
      const workingHours = this.addressData.workingHours;

      if (!this.isWithinWorkingHours(after, workingHours) || !this.isWithinWorkingHours(before, workingHours)) {
        this.toastService.showErrorToasts(
          this.translate.instant('modules.mission.mission_form.datetime_dialog.out_of_working_hours')
        );
        return;
      }
    }

    this.submitEvent.emit({after, before});
  }

}
